import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useReducer } from "react";
import { GET_USE_SERVICE_INITIAL_STATE, USE_SERVICE_REDUCER, } from "./useService";
const DEFAULT_CONTEXT_STATE = {
    state: {},
    dispatch: () => { },
    isEmpty: false,
};
const reducer = (state, action) => {
    var _a;
    switch (action.type) {
        case "USE_SERVICE_ACTION": {
            if (!state[action.payload.id]) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { [action.payload.id]: USE_SERVICE_REDUCER((_a = state[action.payload.id]) !== null && _a !== void 0 ? _a : GET_USE_SERVICE_INITIAL_STATE({ initialData: null }), action.payload.useServiceAction) });
        }
        case "RESET":
            return Object.assign(Object.assign({}, state), { [action.payload.id]: action.payload.state });
        case "REMOVE": {
            return Object.keys(state).reduce((obj, key) => key === action.payload.id ? obj : Object.assign(Object.assign({}, obj), { [key]: state[key] }), {});
        }
        default:
            return state;
    }
};
export const MAKE_SERVICES_COLLECTOR_EMPTY_CONTEXT = React.createContext(Object.assign(Object.assign({}, DEFAULT_CONTEXT_STATE), { isEmpty: true }));
const makeServicesCollector = () => {
    const context = React.createContext(DEFAULT_CONTEXT_STATE);
    const Provider = ({ children }) => {
        // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
        const [state, dispatch] = useReducer(reducer, {});
        return (_jsx(context.Provider, { value: { state, dispatch, isEmpty: false }, children: children }));
    };
    return {
        /**
         * Provider to collect all the state
         */
        Provider,
        /**
         * hook to access global state
         *
         * @returns {unknown}
         */
        useServiceHook: () => {
            const { state, dispatch } = useContext(context);
            const locals = React.useMemo(() => Object.values(state), [state]);
            const global = React.useMemo(() => ({
                isLoading: locals.some((l) => l.isLoading),
                wasSuccessful: locals.some((l) => l.wasSuccessful),
                data: locals.map((l) => l.data),
                hasError: locals.some((l) => l.hasError),
                errorMessage: locals
                    .map((l) => l.errorMessage)
                    .filter((em) => em)
                    .join("; "),
            }), [locals]);
            return {
                // @ts-expect-error - TS2322 - Type '{ isLoading: boolean; wasSuccessful: boolean; data: (T | null | undefined)[]; hasError: boolean; errorMessage: string; }' is not assignable to type 'UseServiceState<undefined[] | T | null>'.
                global,
                locals,
                dispatch,
            };
        },
        /**
         * register method to use in useService calls to register them.
         */
        register: context,
    };
};
export default makeServicesCollector;
